import { defineStore } from "pinia";
import type { listStations,scheduleRequest,scheduleResponse,trainsBookingResponse,trainBookingRequest,trainReportResponse,detailTrainsReportResponse,createPaymentRequest,listPayments,createPaymentResponse,getSeatResponse,changeSeatReq,changeSeatRes } from "~/istypes";
import { useUserStore} from "~/stores/user";

export const useTrainStore = defineStore('train', () => {
    const config = useRuntimeConfig();
    const userStore = useUserStore();

    const saveToLocalStorage = (key: string, data: any) => {
        localStorage.setItem(key, JSON.stringify(data));
    };

    const getStations = async () => {
        try {
            const res = await $fetch<listStations>(`${config.public.ApiRest}stations/train`, {
                method: "GET",
                headers:{
                    "Device-Id": userStore.deviceId(),
                }
            });

            return res;
        } catch (error) {
            console.error("Error fetching:", error);
        }
        
    }

    const getSchedule = async (data: scheduleRequest) => {
        const headers: Record<string, string> = {};

        headers["Device-Id"] = userStore.deviceId();
        
        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`;
        }

        try {
            const res = await $fetch<scheduleResponse>(`${config.public.ApiBase}/trains/get_schedule`, {
                method: "POST",
                body: data,
                headers
            });

            if(res.status?.code == 200){
                saveToLocalStorage('scheduleTrain', res);
            }

            return res;
        } catch (error) {
            return error;
        }
    }

    const booking = async (data: trainBookingRequest) => {
        if(userStore.token){
            try{
                const res = await $fetch<trainsBookingResponse>(`${config.public.ApiBase}/trains/booking`,{
                    method: "POST",
                    body: data,
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                if(res.status?.code == 200){
                    saveToLocalStorage('bookingTrain', res);
                }

                return res;

            }catch(error){
                return error;
            }
        }
    }

    const getListReport = async (start_date?: Date | null, end_date?: Date | null) => {
        if (userStore.token) {
            try {
                const res = await $fetch<trainReportResponse>(`${config.public.ApiBase}/trains/reports`, {
                    method: "POST",
                    body: {
                        start_date: start_date,
                        end_date: end_date,
                    },
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getReportDetail = async (id: number | string) => {
        if (userStore.token) {
            try {
                const res = await $fetch<detailTrainsReportResponse>(`${config.public.ApiBase}/trains/reports/detail`, {
                    method: "POST",
                    body: { transaction_id: id },
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getListPayments = async (id: number | string) => {
        if(userStore.token){
            try {
                const res = await $fetch<listPayments>(`${config.public.ApiBase}/trains/payments`, {
                    method: "POST",
                    body: { transaction_id: id },
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const createPayment = async (data: createPaymentRequest) => {
        if(userStore.token){
            try {
                const res = await $fetch<createPaymentResponse>(`${config.public.ApiBase}/payments/create`, {
                    method: "POST",
                    body: data,
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getSeat = async (data: trainBookingRequest) => {
        if(userStore.token){
            try {
                const res = await $fetch<getSeatResponse>(`${config.public.ApiBase}/trains/get_seat`,{
                    method: "POST",
                    body: data,
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                })

                // if(res.status?.code == 200){
                //     saveToLocalStorage('trainSeats', res);
                // }

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const changeSeat = async(data: changeSeatReq) => {
        if(userStore.token){
            try{
                const res = await $fetch<changeSeatRes>(`${config.public.ApiBase}/trains/change_seat`,{
                    method: "POST",
                    body: data,
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                })

                return res;
            }catch(error){
                return error;
            }
        }
    }


    const cencelBooking = async(id: string | number) => {
        if(userStore.token){
            try{
                const res = await $fetch<changeSeatRes>(`${config.public.ApiBase}/trains/cancel_booking`,{
                    method: "POST",
                    body: { transaction_id: id},
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                })

                return res;

            }catch(error){
                return error;
            }
        }
    }


    return { getStations,getSchedule,booking,getListReport,getReportDetail,getListPayments,createPayment,getSeat,changeSeat,cencelBooking };
});